var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CHeaderNavItem',[_c('CHeaderNavLink',[_c('CIcon',{attrs:{"size":"xl","name":"cil-cart"}}),(_vm.ordersCount != 0)?_c('CBadge',{attrs:{"shape":"pill","color":"primary"}},[_vm._v(_vm._s(_vm.ordersCount))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }